import React, { useEffect, useState } from 'react';
import { FaCalendarAlt, FaComments } from 'react-icons/fa';
import axios from 'axios';

const Blog = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get('https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getBlogPosts')
      .then(res => {
        const sortedPosts = res.data.sort((a, b) => new Date(a.date) - new Date(b.date));
        setPosts(sortedPosts);
      });
  }, []);

  return (
    <div>
      {/* Header */}
      <div className="bg-[#324B8E] w-full h-[380px] flex flex-col justify-center px-16 text-white text-left">
        <h1 className="text-6xl font-bold">Blog</h1>
      </div>

      {/* Blog Posts List */}
      <div className="p-8 bg-[#F2F2F2]">
        <div className="px-[10%]">
        {posts.map((post) => (
          <div key={post.id}>
            <div className="rounded-lg p-6 mb-6">
              
              {/* Author info */}
              <div className="flex items-center mb-4">
                <img
                  src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${post.author_image || 'default.png'}`}
                  alt={post.author_name}
                  className="w-10 h-10 rounded-full mr-4 object-cover"
                />
                <span className="font-semibold">{post.author_name}</span>
              </div>

              {/* Title */}
              <h2 className="text-lg text-black font-bold mb-2">{post.title}</h2>

              {/* Content snippet */}
              <p className="text-black mb-4">
                {post.content}
              </p>

              {/* Metadata */}
              <div className="flex items-center text-gray-500 text-sm space-x-4">
              <div className="flex items-center space-x-2">
                <FaCalendarAlt />
                <span>{post.date}</span>
              </div>

              {/* Separator */}
              <div className="h-4 border-l border-gray-400"></div>

              <div className="flex items-center space-x-2">
                <FaComments />
                <span>{post.comments_count} COMMENTS</span>
              </div>
            </div>
            </div>

            {/* Divider line */}
            <div className="border-t border-gray-300 my-4"></div>
          </div>
        ))}
        </div>
        
      </div>
    </div>
  );
};

export default Blog;
